/**
 * Canonical category list for Mundalo Local Deals.
 * Mirrors backend CANONICAL_CATEGORIES in `routes/local_deals.py`.
 *
 * Used by:
 *   - PortalLocalDeals.js (filter dropdown)
 *   - AdminLocalDeals.js (filter dropdown + create/edit form)
 */
export const LOCAL_DEAL_CATEGORIES = [
  'Restaurant',
  'Bar/Nightlife',
  'Café',
  'Retail',
  'Service',
  'Wellness',
  'Entertainment',
  'Other',
];
